import React, { useState, useEffect, useCallback, useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import {
  fetchCmdbHardware, fetchSistemasCmdb, salvarGarantia,
  adicionarLicenca, removerLicenca, vincularSistema, desvincularSistema,
} from '../../../../api/cmdb';
import './CmdbHardware.css';

function statusGarantia(fim) {
  if (!fim) return null;
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
  const dFim = new Date(fim);
  if (Number.isNaN(dFim.getTime())) return null;
  return dFim >= hoje ? { txt: 'Em garantia', cor: '#198754' } : { txt: 'Garantia vencida', cor: '#dc3545' };
}
function soData(v) { return v ? String(v).slice(0, 10) : ''; }

function CmdbHardware({ codhar, patrimonio, descricao, semCard = false }) {
  const [dados, setDados] = useState(null);
  const [sistemasOpcoes, setSistemasOpcoes] = useState([]);
  const [msg, setMsg] = useState('');

  // garantia
  const [gIni, setGIni] = useState('');
  const [gFim, setGFim] = useState('');
  const [gForn, setGForn] = useState('');

  // nova licença
  const [licNome, setLicNome] = useState('');
  const [licTipo, setLicTipo] = useState('');
  const [licChave, setLicChave] = useState('');
  const [licValidade, setLicValidade] = useState('');

  // novo sistema
  const [novoSis, setNovoSis] = useState('');

  const qrRef = useRef(null);

  const imprimirEtiqueta = () => {
    const svgEl = qrRef.current && qrRef.current.querySelector('svg');
    if (!svgEl) return;
    const svg = new XMLSerializer().serializeToString(svgEl);
    const linha1 = patrimonio ? `Patrimônio: ${patrimonio}` : `Ativo #${codhar}`;
    const desc = (descricao || '').split('\n')[0].slice(0, 60);
    const win = window.open('', '_blank', 'width=420,height=520');
    if (!win) return;
    win.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Etiqueta ${linha1}</title>
      <style>
        * { box-sizing: border-box; }
        body { font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 16px; text-align: center; }
        .etiqueta { display: inline-block; border: 1px solid #000; border-radius: 8px; padding: 14px 18px; }
        .etiqueta svg { width: 180px; height: 180px; }
        .l1 { font-weight: 700; font-size: 15px; margin-top: 8px; }
        .l2 { font-size: 12px; color: #333; margin-top: 2px; max-width: 200px; }
        @media print { body { padding: 0; } }
      </style></head>
      <body>
        <div class="etiqueta">
          ${svg}
          <div class="l1">${linha1.replace(/</g, '&lt;')}</div>
          ${desc ? `<div class="l2">${desc.replace(/</g, '&lt;')}</div>` : ''}
        </div>
        <script>window.onload = function(){ setTimeout(function(){ window.print(); }, 150); };<\/script>
      </body></html>`);
    win.document.close();
  };

  const carregar = useCallback(async () => {
    if (!codhar) return;
    const d = await fetchCmdbHardware(codhar);
    setDados(d);
    if (d && d.garantia) {
      setGIni(soData(d.garantia.garantia_inicio));
      setGFim(soData(d.garantia.garantia_fim));
      setGForn(d.garantia.fornecedor || '');
    }
  }, [codhar]);

  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => { fetchSistemasCmdb().then(setSistemasOpcoes); }, []);

  if (!codhar) return null;

  const salvarG = async () => {
    setMsg('');
    try {
      await salvarGarantia(codhar, { garantia_inicio: gIni || null, garantia_fim: gFim || null, fornecedor: gForn || null });
      setMsg('Garantia salva.');
      carregar();
    } catch (e) { setMsg(e?.response?.data?.error || 'Erro ao salvar garantia.'); }
  };

  const addLicenca = async () => {
    setMsg('');
    if (!licNome.trim()) { setMsg('Informe o nome da licença.'); return; }
    try {
      await adicionarLicenca(codhar, { nome: licNome, tipo: licTipo, chave: licChave, validade: licValidade || null });
      setLicNome(''); setLicTipo(''); setLicChave(''); setLicValidade('');
      carregar();
    } catch (e) { setMsg(e?.response?.data?.error || 'Erro ao adicionar licença.'); }
  };

  const delLicenca = async (id) => {
    try { await removerLicenca(codhar, id); carregar(); } catch (_) {}
  };

  const addSistema = async () => {
    setMsg('');
    if (!novoSis) { setMsg('Selecione um sistema.'); return; }
    try { await vincularSistema(codhar, { codsis: parseInt(novoSis, 10) }); setNovoSis(''); carregar(); }
    catch (e) { setMsg(e?.response?.data?.error || 'Erro ao vincular sistema.'); }
  };

  const delSistema = async (id) => {
    try { await desvincularSistema(codhar, id); carregar(); } catch (_) {}
  };

  const stGar = dados && dados.garantia ? statusGarantia(dados.garantia.garantia_fim) : null;
  const qrValor = `${window.location.origin}/hardware/${codhar}`;

  return (
    <div className={semCard ? 'cmdb cmdb--plain' : 'cmdb card mb-4'}>
      <div className={semCard ? '' : 'card-body'}>
        {!semCard && <h5 className="card-title"><i className="fas fa-sitemap me-2" />CMDB</h5>}
        {msg && <div className="alert alert-info py-1 px-2 small">{msg}</div>}

        <div className="cmdb-grid">
          {/* QR code */}
          <div className="cmdb-bloco cmdb-qr">
            <div className="cmdb-bloco-titulo">Etiqueta (QR)</div>
            <div className="cmdb-qr-box" ref={qrRef}>
              <QRCodeSVG value={qrValor} size={120} includeMargin />
            </div>
            <div className="cmdb-qr-info">
              {patrimonio ? <div><strong>Patrimônio:</strong> {patrimonio}</div> : null}
              <div className="text-muted small">Escaneie para abrir este ativo.</div>
              <button type="button" className="btn btn-outline-secondary btn-sm mt-2" onClick={imprimirEtiqueta}>
                <i className="fas fa-print me-1" />Imprimir etiqueta
              </button>
            </div>
          </div>

          {/* Garantia */}
          <div className="cmdb-bloco">
            <div className="cmdb-bloco-titulo">
              Garantia {stGar && <span className="cmdb-badge" style={{ background: stGar.cor }}>{stGar.txt}</span>}
            </div>
            <div className="cmdb-form-row">
              <label>Início<input type="date" value={gIni} onChange={(e) => setGIni(e.target.value)} className="form-control form-control-sm" /></label>
              <label>Fim<input type="date" value={gFim} onChange={(e) => setGFim(e.target.value)} className="form-control form-control-sm" /></label>
            </div>
            <label className="cmdb-full">Fornecedor<input type="text" value={gForn} onChange={(e) => setGForn(e.target.value)} className="form-control form-control-sm" maxLength={160} /></label>
            <button type="button" className="btn btn-primary btn-sm mt-2" onClick={salvarG}>Salvar garantia</button>
          </div>
        </div>

        {/* Licenças */}
        <div className="cmdb-bloco mt-3">
          <div className="cmdb-bloco-titulo">Licenças de software</div>
          {dados && dados.licencas && dados.licencas.length > 0 ? (
            <table className="table table-sm cmdb-tabela">
              <thead><tr><th>Nome</th><th>Tipo</th><th>Chave</th><th>Validade</th><th /></tr></thead>
              <tbody>
                {dados.licencas.map((l) => (
                  <tr key={l.id}>
                    <td>{l.nome}</td><td>{l.tipo || '-'}</td>
                    <td className="cmdb-chave">{l.chave || '-'}</td>
                    <td>{soData(l.validade) || '-'}</td>
                    <td><button type="button" className="btn btn-link btn-sm text-danger p-0" onClick={() => delLicenca(l.id)}><i className="fas fa-trash" /></button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <div className="text-muted small mb-2">Nenhuma licença cadastrada.</div>}
          <div className="cmdb-licenca-form">
            <input type="text" placeholder="Nome*" value={licNome} onChange={(e) => setLicNome(e.target.value)} className="form-control form-control-sm" />
            <input type="text" placeholder="Tipo" value={licTipo} onChange={(e) => setLicTipo(e.target.value)} className="form-control form-control-sm" />
            <input type="text" placeholder="Chave/serial" value={licChave} onChange={(e) => setLicChave(e.target.value)} className="form-control form-control-sm" />
            <input type="date" title="Validade" value={licValidade} onChange={(e) => setLicValidade(e.target.value)} className="form-control form-control-sm" />
            <button type="button" className="btn btn-secondary btn-sm" onClick={addLicenca}><i className="fas fa-plus" /></button>
          </div>
        </div>

        {/* Sistemas vinculados */}
        <div className="cmdb-bloco mt-3">
          <div className="cmdb-bloco-titulo">Sistemas relacionados</div>
          {dados && dados.sistemas && dados.sistemas.length > 0 ? (
            <div className="cmdb-chips">
              {dados.sistemas.map((s) => (
                <span key={s.id} className="cmdb-chip">
                  {s.nome || ('Sistema ' + s.codsis)}
                  <button type="button" onClick={() => delSistema(s.id)} title="Remover"><i className="fas fa-times" /></button>
                </span>
              ))}
            </div>
          ) : <div className="text-muted small mb-2">Nenhum sistema relacionado.</div>}
          <div className="cmdb-sistema-form">
            <select value={novoSis} onChange={(e) => setNovoSis(e.target.value)} className="form-control form-control-sm">
              <option value="">Selecione um sistema…</option>
              {sistemasOpcoes.map((s) => <option key={s.codsis} value={s.codsis}>{s.nome}</option>)}
            </select>
            <button type="button" className="btn btn-secondary btn-sm" onClick={addSistema}><i className="fas fa-link" /> Vincular</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CmdbHardware;
